import { useState, useEffect } from 'react';

export function useIsMobileScreenSize() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= 1200); 
    }

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
}

export function useLoginGate(user, userLoading, setShowLogin) {
  const isSignedIn = Object.keys(user || {}).length !== 0;

  useEffect(() => {
    if (userLoading) return;
    setShowLogin(!isSignedIn);
  }, [isSignedIn, userLoading, setShowLogin]);

  return isSignedIn && !userLoading;
}
